"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepCompareCallback = void 0;
const tslib_1 = require("tslib");
const fast_deep_equal_1 = tslib_1.__importDefault(require("fast-deep-equal"));
const react_1 = require("react");
function useDeepCompareCallback(callback, deps) {
    const ref = (0, react_1.useRef)();
    if (!ref.current ||
        !ref.current.every((item, index) => (0, fast_deep_equal_1.default)(item, deps[index]))) {
        ref.current = deps;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, react_1.useCallback)(callback, ref.current);
}
exports.useDeepCompareCallback = useDeepCompareCallback;
